import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import { getDirectusClient } from "../../lib/directus";
import {
  createItem,
  readItems,
  readPermissions,
  deleteItem,
} from "@directus/sdk";
import { Button, Modal, Select, Space, Table, message } from "antd";
import { Checkbox, Form, Input } from "antd";
import { Modal as AntModal } from "antd";

import { readUsers } from "@directus/sdk";
import { Link } from "react-router-dom";
import Editar from "./components/Editar";
import { useSelector } from "react-redux";
import validarpermiso from "../../lib/utils";
const { confirm } = AntModal;
function Rutas(props) {
  const [rutas, setRutas] = useState([]);
  const [openmodalcrear, setOpenmodalcrear] = useState(false);
  const [openmodaleditar, setOpenmodaleditar] = useState(false);
  const [coordinadores, setCoordinadores] = useState([]);
  const [rutaeditar, setRutaeditar] = useState({});
  const permisos = useSelector((state) => state.permisos);
  const [fielderror, setFielderror] = useState("");
  const [error, setError] = useState(false);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const userRoleID = useSelector((state) => state.userdata.role?.name);
  const userId = useSelector((state) => state.userdata.id);
  const [bodegas, setBodegas] = useState([]);

  const getBodegas = async () => {
    const directus = await getDirectusClient();
    try {
      const bodegasRes = await directus.request(
        readItems("bodegas", {
          fields: ["id", "nombre"],
          filter: {
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  id: { _eq: userBodega },
                }
              : {}),
          },
        })
      );
      setBodegas(bodegasRes);
    } catch (err) {
      console.error("Error fetching bodegas:", err);
      message.error("Error al cargar las bodegas");
    }
  };
  const userdata = useSelector((state) => state.userdata);
  const getUsers = async () => {
    const directus = await getDirectusClient();
    await directus
      .request(
        readUsers({
          fields: ["*"],
          filter: {
            role: {
              id: "954fe3f5-1726-451e-8979-88dd68c83765",
            },
          },
        })
      )
      .then((result) => {
        console.log(result);
        setCoordinadores(result);
      })
      .catch((e) => console.log(e));
  };
  const getRutas = async () => {
    const directus = await getDirectusClient();
    try {
      const rutasres = await directus.request(
        readItems("rutas", {
          fields: [
            "nombre",
            "coordinador.*",
            "coordinador.coordinador_id.first_name",
            "coordinador.coordinador_id.id",
            "descripcion",
            "id",
          ],
        })
      );
      setRutas(rutasres);
    } catch (err) {
      console.error("Error fetching rutas:", err);
      message.error("Error al cargar las rutas");
    }
  };

  const handleOk = () => {
    setOpenmodalcrear(false);
  };
  const handleCancel = () => {
    setOpenmodalcrear(false);
  };

  const handleCanceleditar = () => {
    setOpenmodaleditar(false);
  };

  const handleDelete = async (record) => {
    confirm({
      title: "¿Está seguro de eliminar esta ruta?",
      content: `Se eliminará la ruta "${record?.nombre}"`,
      okText: "Sí, eliminar",
      okType: "danger",
      cancelText: "No, cancelar",
      async onOk() {
        try {
          const directus = await getDirectusClient();
          await directus.request(deleteItem("rutas", record?.id));
          message.success("Ruta eliminada correctamente");
          getRutas(); // Refresh the data
        } catch (error) {
          console.error("Error deleting ruta:", error);
          message.error("Error al eliminar la ruta");
        }
      },
    });
  };

  useEffect(() => {
    getRutas();
    getUsers();
    getBodegas();
  }, []);

  const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
    },
    {
      title: "Descripcion",
      dataIndex: "descripcion",
    },
    {
      title: "Coordinador",
      dataIndex: "coordinador",
      render: (_, record) => {
        return <p>{record?.coordinador[0]?.coordinador_id?.first_name}</p>;
      },
    },
    {
      title: "Acciones",
      key: "Acciones",
      render: (_, record) => (
        <Space size="middle">
          <Link to={"/circuito/" + record.id + "/" + record.nombre}>
            Circuitos
          </Link>
          <Link to={"/vendedores/" + record.id + "/" + record.nombre}>
            Vendedores
          </Link>

          {validarpermiso("rutas", "update", permisos) ? (
            <Button
              type="link"
              onClick={() => {
                setOpenmodaleditar(true);
                setRutaeditar(record);
              }}
            >
              Editar
            </Button>
          ) : null}

          {validarpermiso("rutas", "delete", permisos) ? (
            <Button type="link" danger onClick={() => handleDelete(record)}>
              Eliminar
            </Button>
          ) : null}
        </Space>
      ),
    },
  ];

  const onFinish = async (r) => {
    const directus = await getDirectusClient();
    await directus
      .request(
        createItem("rutas", {
          coordinador: {
            create: [
              {
                rutas_id: "+",
                coordinador_id: {
                  id: userRoleID.includes("coordinador") ? userId : r?.coordinador,
                },
              },
            ],
            update: [],
            delete: [],
          },
          nombre: r?.nombre,
          descripcion: r?.descripcion,
          bodega: userBodega,
        })
      )
      .then((res) => {
        console.log(res);
        getRutas();
        handleCancel();
      })
      .catch((er) => {
        console.log(er.errors[0].extensions.field);
        setFielderror(er.errors[0].extensions.field);
        setError(true);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Layouts>
      {console.log(userdata)}
      {validarpermiso("rutas", "create", permisos) ? (
        <Button onClick={() => setOpenmodalcrear(true)}>Crear Ruta</Button>
      ) : null}
      {validarpermiso("rutas", "read", permisos) ? (
        <Table dataSource={rutas} columns={columns} />
      ) : (
        <h3>No tiene permisos para ver rutas</h3>
      )}

      <Modal
        title="Crear Ruta"
        open={openmodalcrear}
        onOk={false}
        onCancel={handleCancel}
        footer={null}
      >
        {error ? (
          <p style={{ color: "red" }}>
            El campo {fielderror} ya existe en el sistema{" "}
          </p>
        ) : null}
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Nombre"
            name="nombre"
            rules={[
              {
                required: true,
                message: "ingresar nombre",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Descripcion"
            name="descripcion"
            rules={[
              {
                required: true,
                message: "ingresar descripcion",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Bodega"
            name="bodega"
            rules={[
              {
                required: true,
                message: "Seleccione una bodega",
              },
            ]}
          >
            <Select
              placeholder="Seleccione una bodega"
              showSearch
              optionFilterProp="children"
            >
              {bodegas.map((bodega) => (
                <Select.Option key={bodega?.id} value={bodega?.id}>
                  {bodega?.nombre}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {userRoleID !== "coordinador_ruta" && (
            <Form.Item
              label="Coordinador"
              name="coordinador"
              rules={[
                {
                  required: true,
                  message: "ingresar coordinador",
                },
              ]}
            >
              <Select>
                {coordinadores.map((coordinador) => {
                  return (
                    <Select.Option value={coordinador?.id}>
                      {coordinador?.first_name}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
          )}

          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button type="primary" htmlType="submit">
              Guardar
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Editar
        openmodaleditar={openmodaleditar}
        data={rutaeditar}
        coordinadores={coordinadores}
        handleCanceleditar={handleCanceleditar}
        onSuccess={getRutas}
      />
    </Layouts>
  );
}

export default Rutas;
